import type { ChatPanelContextCardProps } from "./types";

export function ChatPanelContextCard({
  title,
  subtitle,
  icon: Icon,
}: ChatPanelContextCardProps) {
  return (
    <div className="mx-4 p-3 bg-card rounded-xl border border-border flex items-center gap-3 mb-1 ">
      {Icon && <Icon size={20} className="text-secondary shrink-0" />}
      <div className="min-w-0">
        <p className="text-sm font-medium text-primary truncate">{title}</p>
        {subtitle && (
          <p className="text-xs text-secondary truncate">{subtitle}</p>
        )}
      </div>
    </div>
  );
}
